import React, { useState } from 'react';
import { useAudioTracks } from '../utils/audioUtils';
import { useAudioPlayer } from './audio/useAudioPlayer';
import { MinimizedPlayer } from './audio/MinimizedPlayer';
import { MaximizedPlayer } from './audio/MaximizedPlayer';

export function MusicPlayer() {
  const tracks = useAudioTracks();
  const [isMinimized, setIsMinimized] = useState(false);
  
  const {
    audioRef,
    currentTrackIndex,
    isPlaying,
    volume,
    isMuted,
    progress,
    duration,
    setCurrentTrackIndex,
    setIsPlaying,
    setVolume,
    setIsMuted,
    handleProgressClick
  } = useAudioPlayer(tracks);

  if (!tracks.length) return null;

  return (
    <>
      <audio
        ref={audioRef}
        src={tracks[currentTrackIndex]?.path}
        preload="metadata"
        crossOrigin="anonymous"
      />
      
      {isMinimized ? (
        <MinimizedPlayer onMaximize={() => setIsMinimized(false)} />
      ) : (
        <div className="max-w-xl mx-auto"> 
          <div className="relative rounded-lg overflow-hidden">
            {/* Glowing border animation */}
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-indigo-500 rounded-lg animate-border-glow"></div>
            
            {/* Content with glossy background */}
            <div className="relative m-[2px] rounded-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm backdrop-filter">
              <MaximizedPlayer
                title={tracks[currentTrackIndex]?.title}
                isPlaying={isPlaying}
                currentTrackIndex={currentTrackIndex}
                totalTracks={tracks.length}
                progress={progress}
                duration={duration}
                currentTime={audioRef.current?.currentTime || 0}
                volume={volume}
                isMuted={isMuted}
                onMinimize={() => setIsMinimized(true)}
                onPlayPause={() => setIsPlaying(!isPlaying)}
                onPrevious={() => currentTrackIndex > 0 && setCurrentTrackIndex(prev => prev - 1)}
                onNext={() => currentTrackIndex < tracks.length - 1 && setCurrentTrackIndex(prev => prev + 1)}
                onVolumeChange={setVolume}
                onMuteToggle={() => setIsMuted(!isMuted)}
                onProgressClick={handleProgressClick}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}